<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        <div class="text-h4" style="margin-top: 15px;">
            企業情報更新</v-btn>
        </div>

        <!-- 項目 -->
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-container>
                <v-row>
                    <template v-if="plan">
                        <v-col cols="12" xl="2">
                            <badge-component tile content="必　須" color="red">
                                <label-component>会社名</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="5">
                            <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.name" :error-messages="errors" background-color="white" placeholder="貴社名をご入力ください"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="任　意">
                                <label-component>会社名</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="5">
                            <ValidationProvider rules="max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.name" :error-messages="errors" background-color="white" placeholder="貴社名をご入力ください"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </template>
                    <v-col cols="12" xl="5"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>代表者名</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="items.representative" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="任　意">
                                <label-component>TEL</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider name="TEL" rules="numeric|min:10|max:11" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.tel" placeholder="ハイフン無しでご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="2"></v-col>
                    <template v-if="plan">
                        <v-col cols="12" xl="2">
                            <badge-component tile content="必　須" color="red">
                                <label-component>郵便番号</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider name="郵便番号" rules="required|numeric|digits:7" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.zip_code" placeholder="入力すると住所が出力されます" hint="ハイフン無しでご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="6"></v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="必　須" color="red">
                                <label-component>都道府県</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-select outlined clearable v-disabled-icon-focus v-model="items.address_prefecture" :items="list['prefectures']" :error-messages="errors"  background-color="white" placeholder="ご選択ください"></v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="必　須" color="red">
                                <label-component>市区町村</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.address_city" :error-messages="errors" background-color="white" placeholder="例：千代田区七番町"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="2"></v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="必　須" color="red">
                                <label-component>番地１</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.address_address1" :error-messages="errors" background-color="white" placeholder="例：〇丁目△番地"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="任　意">
                                <label-component>郵便番号</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider name="郵便番号" rules="numeric|digits:7" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.zip_code" placeholder="入力すると住所が出力されます" hint="ハイフン無しでご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="6"></v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="任　意">
                                <label-component>都道府県</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider rules="" v-slot="{ errors }">
                                <v-select outlined clearable v-disabled-icon-focus v-model="items.address_prefecture" :items="list['prefectures']" :error-messages="errors"  background-color="white" placeholder="ご選択ください"></v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="任　意">
                                <label-component>市区町村</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider rules="max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.address_city" :error-messages="errors" background-color="white" placeholder="例：千代田区七番町"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="2"></v-col>
                        <v-col cols="12" xl="2">
                            <badge-component tile content="任　意">
                                <label-component>番地１</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <ValidationProvider rules="max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="items.address_address1" :error-messages="errors" background-color="white" placeholder="例：〇丁目△番地"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </template>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>番地２</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="items.address_address2" :error-messages="errors" background-color="white" placeholder="例：〇△ビル３階"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>従業員数</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="" v-slot="{ errors }">
                            <v-select
                                v-model="items.employee_number"
                                :items="list['employees']"
                                outlined
                                clearable
                                v-disabled-icon-focus
                                placeholder="ご選択ください"
                                :error-messages="errors"
                                background-color="white"
                            ></v-select>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>業種</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="" v-slot="{ errors }">
                            <v-select
                                v-model="industry_id"
                                :items="list['industries']"
                                outlined
                                clearable
                                v-disabled-icon-focus
                                placeholder="ご選択ください"
                                :error-messages="errors"
                                background-color="white"
                            ></v-select>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>URL</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="5">
                        <ValidationProvider rules="max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="items.url" :error-messages="errors" background-color="white" placeholder="例：https://www.example.com"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2"></v-col>
                </v-row>
            </v-container>

            <v-container>
                <v-row class="justify-center">
                    <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk" :disabled="invalid">
                        <slot name="ok-btn" :disabled="invalid">保存</slot>
                    </v-btn>
                </v-row>
            </v-container>
        </ValidationObserver>
    </v-container>
</template>

<script>
    const jsonpAdapter = require('axios-jsonp');
    export default {
        data() {
            return {
                // 項目一覧
                items: [],
                industry_id: null,
                list: [],
                plan: false,
                // メッセージ
                message: null,
                success: false,
                sending: false,
            };
        },
        watch: {
            // 住所検索
            'items.zip_code': function(next, prev) {
                // バリデーションチェック
                const reg = /^\d{7}$/;
                if (!reg.test(next)) return;

               axios({
                    url: `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${next}`,
                    adapter: jsonpAdapter, // requireしたアダプタを利用
                })
                .then((res) => {
                    this.items.address_prefecture = res.data.results[0].address1; // 都道府県
                    this.items.address_city = res.data.results[0].address2 + res.data.results[0].address3; // 市区町村
                }).catch(res => {
                    // console.log(res);
                    this.success = false;
                    this.message = "該当する住所が見つかりませんでした";
                }).finally(() => {
                });
            }
        },
        methods: {
            // 更新
            pushOk: async function() {
                this.sending = true;
                await axios.post('/documents/update-companies/' + this.items.id, {
                    name: this.items.name,
                    representative: this.items.representative,
                    tel: this.items.tel,
                    zip_code: this.items.zip_code,
                    address_prefecture: this.items.address_prefecture,
                    address_city: this.items.address_city,
                    address_address1: this.items.address_address1,
                    address_address2: this.items.address_address2,
                    industry_id: this.industry_id,
                    employee_number: this.items.employee_number,
                    url: this.items.url,
                }).then(res => {
                    this.success = res.data.success;
                    this.message = res.data.message;
                }).catch(res => {
                    // console.log(res);
                    this.success = false;
                    this.message = "処理に失敗しました";
                }).finally(() => {
                    this.sending = false;
                });
            },
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-companies').then(res => {
                this.items = res.data.items;
                if (res.data.items.company_industries != null) {
                    this.industry_id = res.data.items.company_industries.industry_id;
                }
                this.list = res.data.list;
                this.plan = res.data.plan;
            });
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .col-12, .col-xl-12 {
        padding: 12px 12px 0 12px;
    }
</style>